export default __webpack_public_path__ + "static/PM_Strawberry-7de46fb436573b06626c630ac6aaaa82.png";